export default {
  "bbt.footer.eventProgram": "イベント・プログラム",
  "bbt.footer.news": "ニュース",
  "bbt.footer.report": "レポート",
  "bbt.footer.supporter": "サポーター",
  "bbt.footer.about": "BBTを知る",
  "bbt.footer.contact": "お問い合わせ",
  "bbt.footer.footerLinks":
    "一般社団法人ライフサイエンス・イノベーション・ネットワーク・ジャパン／Life Science Innovation Network Japan",
} as const;
